import { render } from "./SnackBar.vue?vue&type=template&id=3323d0fc&scoped=true&ts=true"
import script from "./SnackBar.vue?vue&type=script&lang=ts"
export * from "./SnackBar.vue?vue&type=script&lang=ts"

import "./SnackBar.vue?vue&type=style&index=0&id=3323d0fc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3323d0fc"]])

export default __exports__